import React from "react";
import "./Hero.css";
/*
 * title, text, and actions belong to the caller. actions is a slot — the
 * same idea as projecting content into a template — so each page keeps the
 * links it already rendered, and this component only draws the band.
 * The homepage passes no icon and leaves compact off, so those branches
 * add nothing to its tree.
 */
export function Hero({ title, text, actions, icon, compact }) {
    return (React.createElement("div", { className: compact
            ? "redesign-home-hero redesign-home-hero-compact"
            : "redesign-home-hero" },
        React.createElement("div", { className: "redesign-home-hero-inner" },
            React.createElement("div", { className: "redesign-home-hero-copy" },
                icon ? (React.createElement("span", { className: "redesign-home-hero-icon", "aria-hidden": "true" }, icon)) : null,
                React.createElement("h1", { className: "redesign-home-title" }, title),
                React.createElement("p", { className: "redesign-home-description" }, text)),
            React.createElement("div", { className: "redesign-home-actions" }, actions))));
}
